<section
  class="layout"
  [ngClass.lt-sm]="{'xs':true}"
  [ngClass.lt-md]="{'sm':true}"
>
  <h2 fxLayout="row wrap" fxLayoutAlign="center center">
    <span>お客様の声</span>
  </h2>
  <ul fxLayout="row wrap" fxLayoutAlign="center start">
    <li>
      <div class="message">
        <p>先日はありがとうございました。</p>
        <p>初めてなので緊張しながら来院しましたが、とても話しやすく今の自分の体の状態など丁寧にみていただけました。</p>
        <p>爆睡できるほどの心地良さです！女性の方も気軽に行けるので早速友達にもオススメしました！</p>
        <p>自分のケアのため定期的に伺いたいと思います。</p>
      </div>
      <div class="from">
        女性/30代前半
      </div>
    </li>
    <li>
      <div class="message">
        <p>痛くない施術で不思議でしたが、スッキリしました。</p>
      </div>
      <div class="from">
        女性/30代前半
      </div>
    </li>
    <li>
      <div class="message">
        <p>先日はありがとうございました！</p>
        <p>はじめて行ったので、最初緊張しましたが、先生がとても話しやすい方で、色々聞きやすかったです。</p>
        <p>朝早い時間帯だったので、人もあまりいなく、リラックスして施術を受けることができました！</p>
        <p>体の痛みの原因なども教えてくれて、とても満足できました。</p>
        <p>次は骨盤矯正でまた行きたいと思います！</p>
        <p>またよろしくお願いします(^^)</p>
      </div>
      <div class="from">
        女性/30代前半
      </div>
    </li>
    <li>
      <div class="message">
        <p>何十年も前のケガや数年前の事故で首を痛めてから今現在の首の痛みも後遺症からくるものと考え我慢していましたが、頭痛や首以外の痛みが出るようになり治療院に伺いました。</p>
        <p>カイロと聞いて痛いイメージが強かったのですが、全くそんな事はなく痛む箇所ではなく身体と向き合って頂いたと思います。</p>
        <p>前後左右の動作に痛みを感じていた首は施術後左右に動かしても痛みが出る事はなく(前後動作はまだ…)頭が軽く感じました。</p>
        <p>いまだ痛みは出ていません。ありがとうございました。しばらく続けたいと思います。</p>
      </div>
      <div class="from">
        女性/40代
      </div>
    </li>
    <li>
      <div class="message">
        <p>少し緊張しましたが、私の仕事についても共感していただき、気持ちが楽になりました。</p>
        <p>骨盤が気になっていたので、正直もっとゴリゴリしてもらえるのかと期待しましたが、こういう施術後もあるのか～と思いました。</p>
        <p>ありがとうございました。</p>
      </div>
      <div class="from">
        女性/30代前半
      </div>
    </li>
    <li class="more" fxLayout="row" fxLayoutAlign="center center">
      <a href="https://beauty.hotpepper.jp/kr/slnH000467455/review/" rel="noopener noreferrer" target="_blank" fxLayout="row" fxLayoutAlign="center center">
        <span>更に見る</span>
        <mat-icon fontSet="material-icons-outlined">open_in_new</mat-icon>
      </a>
    </li>
  </ul>
</section>
